import {
  IsString,
  IsNotEmpty,
  IsOptional,
  IsBoolean,
  IsUUID,
  MaxLength,
  IsDateString,
  Matches,
} from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class CreateParameterDto {
  @ApiProperty({
    example: 'MAX_LOGIN_ATTEMPTS',
    description: 'Clave única del parámetro en formato SCREAMING_SNAKE_CASE',
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  @Matches(/^[A-Z][A-Z0-9_]*$/, {
    message:
      'La clave debe estar en formato SCREAMING_SNAKE_CASE (ej: MAX_LOGIN_ATTEMPTS)',
  })
  readonly key!: string;

  @ApiProperty({
    example: '5',
    description: 'Valor del parámetro',
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(500)
  readonly value!: string;

  @ApiPropertyOptional({
    example: 'Número máximo de intentos de login permitidos',
    description: 'Descripción del parámetro',
  })
  @IsOptional()
  @IsString()
  @MaxLength(500)
  readonly description?: string;

  @ApiPropertyOptional({
    example: true,
    description: 'Indica si el parámetro está activo',
    default: true,
  })
  @IsOptional()
  @IsBoolean()
  readonly isActive?: boolean;
}

export class UpdateParameterDto {
  @ApiPropertyOptional({
    example: '10',
    description: 'Valor del parámetro',
  })
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(500)
  readonly value?: string;

  @ApiPropertyOptional({
    example: 'Número máximo de intentos de login permitidos',
    description: 'Descripción del parámetro',
  })
  @IsOptional()
  @IsString()
  @MaxLength(500)
  readonly description?: string;

  @ApiPropertyOptional({
    example: true,
    description: 'Indica si el parámetro está activo',
  })
  @IsOptional()
  @IsBoolean()
  readonly isActive?: boolean;
}

export class ParameterResponseDto {
  @ApiProperty({
    example: '123e4567-e89b-12d3-a456-426614174000',
    description: 'ID único del parámetro',
  })
  @IsUUID()
  readonly id!: string;

  @ApiProperty({
    example: 'MAX_LOGIN_ATTEMPTS',
    description: 'Clave única del parámetro',
  })
  @IsString()
  readonly key!: string;

  @ApiProperty({
    example: '5',
    description: 'Valor del parámetro',
  })
  @IsString()
  readonly value!: string;

  @ApiPropertyOptional({
    example: 'Número máximo de intentos de login permitidos',
    description: 'Descripción del parámetro',
  })
  @IsOptional()
  @IsString()
  readonly description?: string;

  @ApiProperty({
    example: true,
    description: 'Indica si el parámetro está activo',
  })
  @IsBoolean()
  readonly isActive!: boolean;

  @ApiProperty({
    example: '2024-01-15T10:30:00Z',
    description: 'Fecha de creación',
  })
  @IsDateString()
  readonly createdAt!: string;

  @ApiPropertyOptional({
    example: '2024-01-15T10:30:00Z',
    description: 'Fecha de última actualización',
  })
  @IsOptional()
  @IsDateString()
  readonly updatedAt?: string;
}
